/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'cvlib';

import './modalError.scss';

const ModalError = props => {
  const { error_mail_modal_title_label } = props.translations;
  const {
    home_ticker_icon_button_close,
    mail_modal_icon_warning,
  } = props.asset;
  const { error_message, onCloseModal } = props;

  const elements = [
    {
      element: 'logo',
      content: mail_modal_icon_warning,
      expand: 3,
      position: 'center',
      style: { width: '44px', height: '40px' },
    },
    {
      element: 'title',
      content: error_mail_modal_title_label,
    },
    {
      element: 'message',
      content: error_message,
    },
  ];

  return (
    <div className="modal-form-register-error-container">
      <Form elements={elements} classes={['modal-form-register-error']} />
      <img
        alt="Close"
        className="modal-form-register-error-close"
        src={home_ticker_icon_button_close}
        onClick={onCloseModal}
      />
    </div>
  );
};

ModalError.propTypes = {
  translations: PropTypes.shape({
    error_mail_modal_title_label: PropTypes.string,
  }),
  asset: PropTypes.shape({
    home_ticker_icon_button_close: PropTypes.string,
    mail_modal_icon_warning: PropTypes.string,
  }),
  error_message: PropTypes.string,
  onCloseModal: PropTypes.func,
};

export default ModalError;
